import "./Home.css";
import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";

let LetsPlayGIF = "https://c.tenor.com/FnMFDXJubNkAAAAM/dannychavinha-squidgame.gif";
import GameDog from "../../Images/game-dog.gif";
import ThinkAboutIt from "../../Images/think-about-it.gif";
import Fun from "../../Images/maza-aaya.gif";
import PaisaHoga from "../../Images/paisa-hoga.gif";
import ArraysCard from "../../Images/ArraysCard.png";
import SearchingCard from "../../Images/SearchingCard.png";

export default class Home extends React.Component {
	render() {
		return (
			<main>
				<Header />
				<div className="container-1">
					<div className="left-container-1">
						<h1>
							Gamified
							<br />
							CP
						</h1>
						<p>
							An <b>ALL-IN-ONE platform</b>, where one can learn
							DSA in an interactive gamified environment, while
							having fun playing our mini-games that visualize the
							concepts of how various data structures and
							algorithms work.
						</p>
					</div>
					<div className="right-container-1">
						<img src={LetsPlayGIF} />
					</div>
				</div>
				<div id="hr"><hr/></div>

				{/* ----------------------------------- */}

				<div className="benefits-container">
					<h2>Benefits</h2>
					<div className="benefits">
						{/* Benefit div 1 */}
						<div className="benefit-div">
							<div className="benefit">
								<img className="gifDiv" src={GameDog} />
								<h3>Interactive</h3>
								<p>
									GCP is a very interactive platform where you can learn the concepts of data structures and algorithms via our interactive sub-bundle mini-games and  interact with the game objects to visualize the concepts. Our games are made in simple <b>HTML+CSS+JS</b>.
								</p>
							</div>
							<div className="benefit">
								<img className="gifDiv" src={ThinkAboutIt} />
								<h3>Cognition</h3>
								<p>
									Our platform is inspired from psychological studies on the effect of games on cognition and the learning curve. Gamification and learning go hand-in-hand in our platform. Check out this article on <b><a id="game-article" href="https://belitsoft.com/custom-elearning-development/gamification-in-elearning">gamification in learning</a></b>.
								</p>
							</div>
						</div>
						{/* Benefit div 2 */}
						<div className="benefit-div">
							<div className="benefit">
								<img className="gifDiv" src={Fun} />
								<h3>Funtainment</h3>
								<p>
									GCP is fun combined with entertainment, i.e. funtainment. You will not be bored as we use the combination of <b>funny GIFs, animations and our sub-bundle games</b> to keep you engaged in learning. Every bundle will help you visualize DSA.
								</p>
							</div>
							<div className="benefit">
								<img
									id="paisa-hoga"
									className="gifDiv"
									src={PaisaHoga}
								/>
								<div></div>
								<h3>High ROI</h3>
								<p>
									When you purchase a GCP priced bundle, you are investing in something that has a high ROI, i.e. <b>return on investment.</b> Don't think of GCP as a liability, that is bleeding cash in and out. GCP is a healthy investment in your coding career.
								</p>
							</div>
						</div>
					</div>
				</div>
				<div id="hr"><hr/></div>

				{/* ----------------------------------- */}

				<div className="get-started">
					<h1>
						<span id="gs-1">Get started with</span>
						<span id="gs-2">with these</span>
						<span id="gs-3">FREE GAME BUNDLES!</span>
					</h1>
				</div>
				<div className="cards-container">
					<Link to="/games/arrays">
						<img className="card1" src={ArraysCard} />
					</Link>
					<Link to="/games/searching">
						<img className="card2" src={SearchingCard} />
					</Link>
				</div>
				<div id="hr"><hr/></div>

				{/* ----------------------------------- */}

				<div className="full-access">
					<h1>
						To get full access, <br /> check out &nbsp;
						<Link to="/pricing">
							<span id="pricing-span">Pricing</span>
						</Link>
					</h1>
				</div>
			</main>
		);
	}
}
